export default __webpack_public_path__ + "static/media/transportation-colored.98bd267f.svg";